export default __webpack_public_path__ + "static/media/companyBlack.0bfd79c9.svg";